import { gql } from 'react-apollo';

export const getCurrentChurchMembers = gql`
  query getCurrentChurchMembers($churchId: Int!) {
    church: church_by_id(id: $churchId) {
      id
      churchMembers: church_members {
        edges {
          node {
            id
            name
            email
            joined: created_at
            registrationRevivalDay: registration_revival_day
            registrationRevivalPhase: registration_revival_phase
            photo {
              small
            }
            group: church_group {
              id
              name
            }
          }
        }
      }
      groups: church_groups {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/pages/churchMembers/queries/getCurrentChurchMembers.js